import { Field, Form, Formik } from "formik";
import { useIntl } from "react-intl";
import { Input } from "../../../common/control/InputField";
import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { PromotionListDialog } from "../promotionListDialog/PromotionListDialog";
import { PromotionItem } from "../promotionListDialog/PromotionItem";

export const TransferInForm = ({
  formikRef,
  saveValues,
  selMemberId,
  selCompanyName,
  selBalance,
  selCompanyCode,
  selGameRate,
  inputRef,
}) => {
  const intl = useIntl();
  const [show, setShow] = useState(false);
  const memberState = useSelector(({ member }) => member, shallowEqual);

  const getSelectedPromo = (promotionid) =>
    memberState.memberGameBalance?.promotionListsV2?.find(
      (promo) => promo?.promotionid === promotionid
    );

  const getLastSelectedPromo = () =>
    memberState.memberGameBalance?.promotionListsV2?.find(
      (promo) => promo?.selected === "true"
    );

  return (
    <>
      <Formik
        initialValues={{
          amount: "",
          promotionid: "",
        }}
        innerRef={formikRef}
        enableReinitialize={true}
        onSubmit={(values, formikHelpers) => {
          if (values.amount != null || values.amount != "0") {
            let queryParams = {
              action: "membertopup_directV2",
              memberid: selMemberId,
              companycode: selCompanyCode,
              amount: values.amount,
              promotionid: values.promotionid,
            };
            saveValues(queryParams);
          } else {
            formikHelpers.setFieldError(
              "amount",
              intl.formatMessage({ id: "invalidAmount" })
            );
          }
        }}
      >
        {({
          values,
          handleSubmit,
          setFieldValue,
          touched,
          errors,
          setFieldError,
        }) => (
          <Form>
            <PromotionListDialog
              setShow={setShow}
              show={show}
              promotionid={values.promotionid}
              setFieldValue={setFieldValue}
            />
            <div>
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                }}
              >
                <div>{selCompanyName}</div>
                <div>
                  {intl.formatMessage({ id: "balance" }) + " : " + selBalance}
                </div>
              </div>
            </div>
            <div
              className="my-2"
              style={{ borderBottom: "1px solid rgb(175, 164, 164, 0.2)" }}
            ></div>
            <div className="mb-2">
              <label className="mb-2 text-input-label">
                {intl.formatMessage({ id: "amount" })}
              </label>

              <Field
                name="amount"
                component={Input}
                placeholder="0.00"
                autoComplete="off"
                type="number"
                autoFocus={true}
                innerRef={inputRef}
              />
            </div>
            {memberState.memberGameBalance?.promotionListsV2.length > 0 && (
              <div className="mb-2">
                <label className="mb-2 text-input-label">
                  {intl.formatMessage({
                    id: getLastSelectedPromo()
                      ? "lastSelectedPromotion"
                      : "promotion",
                  })}
                </label>
                {!getLastSelectedPromo() ? (
                  values.promotionid === "" &&
                  !getSelectedPromo(values.promotionid) ? (
                    <div
                      className="d-flex align-items-center justify-content-center border rounded p-5"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShow(true)}
                    >
                      <div>
                        {intl.formatMessage({ id: "clickToSelectPromo" })}
                      </div>
                    </div>
                  ) : (
                    <PromotionItem
                      promo={getSelectedPromo(values.promotionid)}
                      onClick={() => {
                        setShow(true);
                      }}
                    />
                  )
                ) : (
                  <PromotionItem promo={getLastSelectedPromo()} />
                )}
              </div>
            )}

            <div
              className="d-flex justify-content-between"
              style={{
                fontSize: "15px",
                color: "gray",
              }}
            >
              <div>
                {intl.formatMessage({ id: "gamerate" }) + " : " + selGameRate}
              </div>
              {memberState.memberGameBalance?.promolock && (
                <div>
                  {intl.formatMessage({ id: "promoLock" }) + " : "}
                  <span
                    className={
                      parseFloat(memberState.memberGameBalance?.promolock) > 0
                        ? "text-danger"
                        : ""
                    }
                  >
                    {memberState.memberGameBalance?.promolock}
                  </span>
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
